module.exports = "/_next/static/images/Understand@3x-053c0d2c3abcd31e77e57b5e05288d4d.png";